import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, SummaryItem, SummaryTopComponent, TabComponent } from '../../../../tms-shared';
import { RoleDetails } from '../../models';
import { RoleService } from '../../services';
import { RoleDetailsComponent } from '../role-details/role-details.component';
import { RoleDocumentsComponent } from '../role-documents/role-documents.component';
import { RoleMenuItemsComponent } from '../role-menu-items/role-menu-items.component';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss',
  imports: [
    SummaryTopComponent,
    TabComponent,
    RoleDetailsComponent,
    RoleMenuItemsComponent,
    RoleDocumentsComponent,
    AsyncPipe,
  ],
})
export class RoleComponent extends BaseComponent implements OnInit {
  private readonly roleService = inject(RoleService);
  private readonly route = inject(ActivatedRoute);

  protected readonly detailsHeader = $localize`Details`;
  protected readonly menusHeader = $localize`Menus`;
  protected readonly labelsHeader = $localize`Labels`;

  protected model$: Observable<RoleDetails>;

  private id: string;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  summaryTopItems(model: RoleDetails): SummaryItem[] {
    return [
      { label: $localize`Name`, value: model.name },
      { label: $localize`Description`, value: model.description },
    ];
  }

  getModel(): void {
    if (this.id) {
      this.model$ = this.roleService.edit(this.id).pipe(takeUntil(this.destroy$));
    }
  }
}
